import Vue from 'vue'
import Vuex, { Module } from 'vuex'
import InvoiceRuleModel from '@/models/InvoiceRuleModel'
import { notification } from 'ant-design-vue'

Vue.use(Vuex)

export const invoiceRuleStore: Module<any, any> = {
  state: {
    invoiceRuleList: {
      data: [],
      meta: {
        per_page: 25,
        total: 0
      }
    },
    loading: {
      list: false,
      item: false,
      save: false
    },
    errors: {}
  },
  mutations: {
    setInvoiceRuleList (state, { invoiceRuleList }) {
      state.invoiceRuleList = invoiceRuleList
    },
    setLoading (state, data) {
      state.loading[data.type] = data.state
    }
  },
  actions: {
    getInvoiceRuleList ({ commit }, data) {
      commit('setLoading', { type: 'list', state: true })
      let invoiceRuleModel = new InvoiceRuleModel()

      // Add filters if there are any filters set.
      if (data.activeFilters) {
        Object.keys(data.activeFilters).forEach(key => {
          if (data.activeFilters[key].length) {
            invoiceRuleModel = invoiceRuleModel.whereIn(key, data.activeFilters[key])
          }
        })
      }

      // Add search if available.
      if (data.search) {
        invoiceRuleModel = invoiceRuleModel.where('search', data.search)
      }

      // Add orderBy if sort is set.
      if (data.sort) {
        invoiceRuleModel = invoiceRuleModel.orderBy(data.sort.order === 'ascend' ? data.sort.columnKey : '-' + data.sort.columnKey)
      }

      if (data.pagination) {
        invoiceRuleModel = invoiceRuleModel.limit(data.pagination.pageSize).page(data.pagination.current)
      }

      invoiceRuleModel.get().then((invoiceRuleList) => {
        commit('setInvoiceRuleList', { invoiceRuleList })
      }).catch(() => {
        notification.error({ message: 'Fout tijdens het ophalen van de factuurregels!', description: 'Er is iets mis gegaan. Probeer het later nog een keer.', duration: 3 })
      }).finally(() => {
        commit('setLoading', { type: 'list', state: false })
      })
    }
  },
  getters: {
    invoiceRuleList: state => state.invoiceRuleList,
    loadingInvoiceRule: state => state.loading
  }
}
